import { render, staticRenderFns } from "./renTal.vue?vue&type=template&id=3dc290d2&scoped=true"
import script from "./renTal.vue?vue&type=script&lang=js"
export * from "./renTal.vue?vue&type=script&lang=js"
import style0 from "./renTal.vue?vue&type=style&index=0&id=3dc290d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc290d2",
  null
  
)

export default component.exports